import { Trash16, Users16 } from '@yunex/yds-icons';
import { Button, Stack, ToggleButton, Tooltip } from '@yunex/yds-react';
import React from 'react';
import { CMP_EDIT_VIEWS_DIALOG as CMP } from '../../../componentNames';
import { t } from '../../../../localization/getTranslation';
export var EditViewsActionsCellRenderer = function (_a) {
    var _b = _a.value, value = _b === void 0 ? false : _b, node = _a.node, context = _a.context;
    var handleVisibilityChange = function () { return node.setDataValue('isForAllUsers', !value); };
    var handleDelete = function () {
        context.setRowData(function (rowData) {
            return rowData.filter(function (row) { return row.id !== node.data.id; });
        });
    };
    return (React.createElement(Stack, { alignItems: "center", direction: "row", height: 1, spacing: 0.5 },
        context.isAdmin && (React.createElement(Tooltip, { placement: "left", title: t('setForAllUsers') },
            React.createElement("div", null,
                React.createElement(ToggleButton, { "aria-label": t('setForAllUsers'), "data-testid": "".concat(CMP, "-users-toggleButton"), onChange: handleVisibilityChange, selected: value, sx: { px: 1, mx: 0.5 }, value: value },
                    React.createElement(Users16, null))))),
        React.createElement(Tooltip, { placement: "left", title: t('delete') },
            React.createElement(Button, { "aria-label": t('delete'), color: "tertiary", "data-testid": "".concat(CMP, "-delete-button"), icon: true, onClick: handleDelete },
                React.createElement(Trash16, null)))));
};
//# sourceMappingURL=EditViewsActionsCellRenderer.js.map